import { WinCard } from 'src/components/win-card';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(WinCard.displayName, WinCard);

export default WinCard;

export { WinCard };
